import { render, staticRenderFns } from "./AppointmentDetailView.vue?vue&type=template&id=0b808b5e&scoped=true"
import script from "./AppointmentDetailView.vue?vue&type=script&lang=js"
export * from "./AppointmentDetailView.vue?vue&type=script&lang=js"
import style0 from "./AppointmentDetailView.vue?vue&type=style&index=0&id=0b808b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b808b5e",
  null
  
)

export default component.exports